import axios from 'axios'

export default {
  /**
   * Get all available report types
   */
  getReportRows({ commit, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getReportRows', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      if (payload.placeId > 0 && payload.zone !== '') {
        payload.zone = ''
      }
      try {
        const config = {
          params: payload,
          responseType: 'json',
          headers: {
            Authorization: `Bearer ${rootState.authentication.jwt}`
          }
        }
        axios
          .get(`${process.env.VUE_APP_URL}/adminapi/reports`, config)
          .then(response => {
            resolve(response.data)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getReportRows', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Get all available report types
   */
  getReportTypes({ commit, rootState, dispatch }) {
    commit(
      'app/setLoading',
      { type: 'getReportTypes', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`
        }
      }
      axios
        .get(`${process.env.VUE_APP_URL}/adminapi/report-types`, config)
        .then(response => {
          commit('setSelectedReportType', response.data[0])
          commit('setReportTypes', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getReportTypes', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Get all available operators
   */
  getOperators({ commit, rootState, dispatch }, payload) {
    commit(
      'app/setLoading',
      { type: 'getOperators', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`
        }
      }
      let url = `${process.env.VUE_APP_URL}/adminapi/placeprofiles?`
      if (payload && payload.region) {
        url += `&region=${payload.region}`
      }
      if (payload && payload.type) {
        url += `&type=${payload.type}`
      }
      axios
        .get(url, config)
        .then(response => {
          commit('setOperators', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getOperators', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Generates Excel reports file for payout
   */
  getPayoutXLSX({ commit, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'generateXLSX', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          params: {
            from: payload.from,
            to: payload.to,
            region: payload.region,
            type: payload.type,
            reportType: payload.reportType,
            groupBy: payload.groupBy,
            placeId: payload.placeId
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${rootState.authentication.jwt}`,
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        }
        const url = `${process.env.VUE_APP_URL}/adminapi/reports`
        axios
          .get(url, config)
          .then(response => {
            resolve(response)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'generateXLSX', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Generates Excel reports file for finance
   */
  getFinanceXLSX({ commit, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getFinanceXLSX', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          params: {
            from: payload.from,
            to: payload.to,
            region: payload.region,
            type: payload.type,
            reportType: payload.reportType,
            groupBy: payload.groupBy,
            placeId: payload.placeId
          },
          responseType: payload.responseType ? payload.responseType : 'blob',
          headers: {
            Authorization: `Bearer ${rootState.authentication.jwt}`,
            Accept: payload.accept
              ? payload.accept
              : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        }
        const url = `${process.env.VUE_APP_URL}/adminapi/reports/finance`
        axios
          .get(url, config)
          .then(response => {
            resolve(response)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'generateXLSX', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  }
}
